package com.cybersoftsolution.cybersoftsolutionweb.components.indicators

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

    @Composable
    fun LoadingIndicator(modifier: Modifier = Modifier,size: Int = 3) {
        Box(
            contentAlignment = Alignment.Center,
            modifier = Modifier
                .fillMaxSize()
                .height(100.vh)
                .padding(topBottom = 50.px)
                .then(modifier)

        ) {
            Div(
                attrs = Modifier
                    .classNames("spinner-border","text-primary")
                    .styleModifier {
                        property("width","${size}rem")
                        property("height","${size}rem")
                    }
                    .toAttrs()
            ) {
                Span(
                    attrs = Modifier
                        .classNames("visually-hidden")
                        .toAttrs()

                ) {
                    Text("Loading ...")
                }
            }

             Div(
                attrs = Modifier
                    .classNames("spinner-grow","text-warning")
                    .styleModifier {
                        property("width","${size-1}rem")
                        property("height","${size-1}rem")
                    }
                    .toAttrs()
            ) {
                Span(
                    attrs = Modifier
                        .classNames("visually-hidden")
                        .toAttrs()

                ) {
                    Text("Loading ...")
                }
            }


        }

    }